import type { RelatedProductItem } from '@libs/common-types';
import { PharmacyType } from '@libs/core';

type QuickAddEligibilityProduct = Pick<RelatedProductItem, 'pharmacyType' | 'isPersonalized' | 'isLivePet'>;

export const isQuickAddEligible = ({ pharmacyType, isPersonalized, isLivePet }: QuickAddEligibilityProduct): boolean =>
    pharmacyType !== PharmacyType.MED && pharmacyType !== PharmacyType.FOOD && !isPersonalized && !isLivePet;
